<template>
  <button
    :disabled="(loading || !eventSelected)"
    class="btn btn-wd btn-fill btn-info"
    @click="runReport()"
  >
    Gerar relatório simplificado de lâmpadas
  </button>
</template>

<script>
import blobUtils from 'blob-util'
import downloadJs from 'downloadjs'
// import { flattenOb ject } from 'src/services/Helper'
import { mapGetters } from 'vuex'
import Couchdb from 'src/services/Couchdb'
import LGPD from 'src/services/LGPD'

export default {
  name: 'lamps-report-simplified',
  props: ['eventSelected', 'allEvents', 'csvSeparator', 'enableLGPD'],
  data () {
    return {
      lamps: [],
      events: {},
      csvHeaders: {
        lamps: {
          'event.reference': 'Referência',
          'event.city': 'Município',
          'customer.uc': 'UC',
          'customer.holder': 'Titular',
          'customer.address.city': 'Cidade',
          'user': 'Atendente da troca',
          'items': {
            'type': 'Tipo',
            'power': 'Potência',
            'room': 'Cômodo',
            'usageHoursPerDay': 'Quantidade de Horas',
            'rushHour': 'Lâmpada utilizada em horário de pico?'
          },
          'createdAt': 'Data da troca da lâmpada'
        }
      },
      loading: false
    }
  },
  methods: {
    resetValues () {
      this.lamps = []
    },
    async runReport () {
      this.$emit('progress', { current: 0, total: 0 })
      this.loading = true
      this.resetValues()
      try {
        this.events = await this.getEvent()
        this.lamps = await this.getLamps()
        if (this.lamps.length > 0) {
          this.getReportLamps()
        } else {
          this.$notify('Não há lâmpadas para este evento')
        }
      } catch (e) {
        console.log(e)
        this.$notify({
          message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
          type: 'danger'
        })
      } finally {
        this.loading = false
      }
    },
    async getEvent () {
      return Promise.all(this.eventSelected.map(
        async (eventId) => {
          let event = await Couchdb.collection('events').find(eventId)
          return event
        }
      ))
    },
    async getCustomer (customerId) {
      return Couchdb.db(process.env.DB_NAME).limit(999999).collection('customers').find(customerId)
    },
    async getLamps () {
      let promiseLamps = this.eventSelected.reduce(
        async (lastLamps, eventId) => {
          let lamps = await Couchdb.db(process.env.DB_NAME).limit(999999).collection('lamps').where('eventId', eventId).get()
          lamps = lamps.map(lamp => {
            let eventId = lamp.eventId
            let event = this.events.find((event) => event._id === eventId)
            lamp.user = this.usersIdName[lamp.userId]
            lamp.event = {
              reference: event.reference,
              city: event.city
            }
            return this.getCustomer(lamp.customer.id).then((customer) => {
              console.log('customer', customer)
              lamp.customer.address = customer.address
              return lamp
            })
          })
          let newLamps = lamps ? [...lastLamps, ...lamps] : lastLamps
          return newLamps
        }
      , [])
      return promiseLamps.then((allLamps) => Promise.all(allLamps))
    },
    getReportLamps () {
      let csv = ''
      csv += this.addHeader(this.csvHeaders.lamps)
      csv += `\n`
      let itemKeys = Object.keys(this.csvHeaders.lamps.items)
      let itemIndex = 0
      let total = this.lamps.reduce((acc, cur) => cur.items ? acc + cur.items.length : acc + 0, 0)
      this.lamps.forEach((lamp) => {
        if (lamp.items && lamp.items.length) {
          lamp.items.forEach((item, i) => {
            csv += `${lamp.event.reference}${this.csvSeparator}`
            csv += `${lamp.event.city}${this.csvSeparator}`
            csv += `${lamp.customer.uc}${this.csvSeparator}`

            csv += `${this.getHolderName(lamp.customer)}${this.csvSeparator}`

            csv += `${lamp.customer.address ? lamp.customer.address.city : '"-"'}${this.csvSeparator}`
            csv += `${lamp.user}${this.csvSeparator}`
            itemKeys.forEach((itemKey) => {
              if (itemKey === 'rushHour') {
                csv += item[itemKey] ? `Sim${this.csvSeparator}` : `Não${this.csvSeparator}`
              } else {
                csv += itemKey ? `${item[itemKey]}${this.csvSeparator}` : `${this.csvSeparator}`
              }
            })
            csv += `${this.$moment(new Date(lamp.createdAt).toISOString())
              .format('DD-MM-YYYY HH:mm:ss')}${this.csvSeparator}`
            csv += `\n`
            itemIndex++
            this.$emit('progress', {current: itemIndex, total})
          })
        }
      })
      this.download(csv)
    },
    addHeader (headers) {
      let csv = ''
      Object.keys(headers).forEach((header) => {
        if (headers[header] !== null && typeof headers[header] === 'object') {
          csv += this.addHeader(headers[header])
        } else {
          csv += `${headers[header]}${this.csvSeparator}`
        }
      })
      return csv
    },
    download (csv) {
      let blob = blobUtils.createBlob([csv], { type: 'text/plain' })
      let date = this.$moment(new Date()).format('DD-MM-YYYY')
      downloadJs(blob, `Relatório_Simplificado_Lampadas_${date}.csv`)
    },

    getHolderName (customer) {
      if (this.enableLGPD) {
        return LGPD.obfuscateString(customer.holder)
      }

      return customer.holder
    }
  },
  computed: {
    ...mapGetters('users', ['usersIdName'])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Reports/LampsReportSimplified.vue